export function formatRelativeTime(timestamp, t) {
    const seconds = Math.floor((Date.now() - new Date(timestamp).getTime()) / 1000);
    if (seconds < 60)
        return t('time.justNow');
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60)
        return t('time.minutesAgo', { count: minutes });
    const hours = Math.floor(minutes / 60);
    if (hours < 24)
        return t('time.hoursAgo', { count: hours });
    const days = Math.floor(hours / 24);
    return t('time.daysAgo', { count: days });
}
//# sourceMappingURL=time.js.map